import React, {useEffect, useState} from 'react'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button'
import MuiStyles from './MuiStyles';
import ConnectionFinder from '../api/ConnectionFinder';
import Result from './Result';
import Loading from './Loading';
import { urlCheck } from './functions/reqHandler';
import LimitPage from './LimitPage';

const IframeMain = () => {
  
  useEffect(() => {
      if (document.referrer) {
        const fetchData = async () => {
          if(await urlCheck(document.referrer)){
            setResult(<LimitPage />)
          }
        }
        fetchData();
      } 
      else {
        document.location.replace("/show")
      }
  },[])

  const [cities, setCities] = useState([])
  const [addresses, setAddresses] = useState([])
  const [numbers, setNumbers] = useState([])
  const [egon, setEgon] = useState("")
  const [result, setResult] = useState()

  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [number, setNumber] = useState("");
  
  const handleCityChange = (event, newValue) => {
    setCity(newValue);
    setAddress(null);
    setNumber(null);
    setAddresses([])
    setNumbers([])
  };

  const handleAddressChange = (event, newValue) => {
    setAddress(newValue);
    setNumber(null);
    setNumbers([])
  };

  const handleNumberChange = (event, newValue) => {
    setNumber(newValue);
  };

  const ricercaComune = (e) => {
    const value = e.target.value

    if(value.length !== 3) return;

    ConnectionFinder.post("/require/name", {
      name: value,
    }).then((response) => {
      let result = response.data;
      result.sort((a, b) =>  {return a.Denominazione_in_italiano.length - b.Denominazione_in_italiano.length});
      setCities(result)
    })
  }

  let ricercaIndirizzo = (e) => {
    const value = e.target.value;
    const previousValue = document.getElementById('cname').value;

    if(previousValue.trim().length === 0) return alert("Inserisci prima il comune.");

    if(value.length === 0) {
      setCities([])
      setAddresses([])
      setNumbers([])
    }

    else if(value.length === 3) {      
      ConnectionFinder.post("/require/address", {
        name: value,
        city: previousValue,
      }).then((response) => {
        let result = response.data
        result.sort((a, b) => a.address.length - b.address.length);
        setAddresses(result)
      })
    }
  
  }

  const getEgon = (address, addrList) => {
    let egon = "0";
    addrList.forEach(element => {
        if(element.address === address) {
            egon = element.egon
            setEgon(element.egon)
        }
    });
    return egon;

  }

  let ricercaCivico = (e) => {
    const value = e.target.value;
    const city = document.getElementById('cname').value
    const previousValue = document.getElementById('address').value
    
    if(previousValue.trim().length === 0) return alert("Inserisci prima l'indirizzo.");
    
    if(value.length !== 1) return;
        
    ConnectionFinder.post("/require/number", {
      name: value,
      address: getEgon(previousValue, addresses),
      city
    }).then((response) => {
      setNumbers(response.data)
    })

  }

  const getResult = async () => {
    const city = document.getElementById('cname').value
    const address = document.getElementById('address').value
    const number = document.getElementById('number').value

    if(city.length === 0) return alert("Inserire almeno il comune.")
    if(address.length > 0 && number.length === 0) return alert("Inserire civico.")

    await setResult(<Loading />);

    let element = document.getElementById('resultSection'); 
    element.scrollIntoView({behavior: 'smooth'});

    const check = await urlCheck(document.referrer, true); 

    if(check) {
      return setResult(<LimitPage />)
    }else{
      ConnectionFinder.post("/require/results", {
        city: city,
        address: address,
        number: number,
        egon: egon,
        map: true
      }).then((response) => {
        setResult(<Result data={response.data}/>)
      })
    }
    
  }

  return(
    <div style={{height: '100%', dispaly: 'flex', alignItems: 'center', justifyContents: 'center', backgroundColor: 'white', width: '100%', margin: 'auto', overflowX: 'hidden'}} >
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'column', height: '420px', paddingBottom: '20px'}}>
        <h1 style={{color: 'white', backgroundColor: '#ff0f64', padding: '10px', borderRadius: '4px'}}>Ricerca copertura</h1>
        <Autocomplete
          disableClearable
          disablePortal
          value={city}
          onChange={handleCityChange}
          id="cname"
          options={cities.map((option) => option.Denominazione_in_italiano.toUpperCase())}
          sx={{...MuiStyles.AutoComplete}}
          renderInput={(params) => <TextField onChange={(e) => ricercaComune(e)} {...params} label="Comune" sx={{...MuiStyles.TextField}} />}
        />
        <Autocomplete
          disableClearable
          disablePortal
          value={address}
          onChange={handleAddressChange}
          id="address"
          options={addresses.map((option) => option.address)}
          sx={{...MuiStyles.AutoComplete}}
          renderInput={(params) => <TextField onChange={(e) => ricercaIndirizzo(e)} {...params} label="Indirizzo" sx={{...MuiStyles.TextField}} />}
        />
        <Autocomplete
          disableClearable
          disablePortal
          value={number}
          onChange={handleNumberChange}
          id="number"
          options={numbers.map((option) => option.civic)}
          sx={{...MuiStyles.AutoComplete}}
          renderInput={(params) => <TextField onChange={(e) => ricercaCivico(e)} {...params} label="Civico" sx={{...MuiStyles.TextField}} />}
        />
        <Button onClick={() => getResult()} 
          variant='contained'
          sx={{
            height: '50px',
            width: '260px',
            fontWeight: 'bold',
            borderRadius: '11px',
            backgroundColor: '#ff0f64',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#e0e0e0',
            },
        }}>Cerca</Button>
      </div>
      {result}        
    </div>  
  )


}

export default IframeMain;
